import React, { createContext } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { ROUTE_CODES } from 'js/config/routes';

export interface RendererContextType {
  isRenderer: boolean;
}

export const RendererContext = createContext<RendererContextType>({
  isRenderer: false
});

export const RendererContextProvider = ({ children }: { children: React.ReactNode }) => {
  const match = useRouteMatch(ROUTE_CODES.RENDER);

  return <RendererContext.Provider value={{ isRenderer: !!match }}>{children}</RendererContext.Provider>;
};

export const useRendererContext = () => {
  return React.useContext(RendererContext);
};
